function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import ACTIONS from './constants';
export function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    profile: {
      model: null,
      error: null,
      fetching: false,
      fetched: false
    },
    user: {
      sessions: [],
      integrations: []
    },
    tags: [],
    fetchingSocialsEntities: [],
    socialsEntities: [],
    subscriptions: {
      fetching: false,
      fetched: false,
      profiles: [],
      products: [],
      tags: []
    },
    likes: {
      fetching: false,
      fetched: false,
      profiles: [],
      products: [],
      articles: [],
      reviews: [],
      answers: []
    },
    services: [],
    loginAction: {},
    profiles: [],
    favorites: {
      fetching: false,
      fetched: false,
      products: []
    },
    viewedTags: {
      fetching: false,
      fetched: false,
      items: []
    },
    viewedProducts: {
      fetching: false,
      fetched: false,
      items: []
    }
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'OPEN_OVERLAY':
      {
        var newState = _objectSpread({}, state);
        newState.loginAction = action.overlayAction;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'CLOSE_OVERLAY':
      {
        var _newState = _objectSpread({}, state);
        _newState.loginAction = {};
        return _objectSpread(_objectSpread({}, state), _newState);
      }
    case 'SET_USER':
      {
        var _newState2 = _objectSpread({}, state);
        _newState2.user = _objectSpread(_objectSpread({}, _newState2.user), action.user);
        return _objectSpread(_objectSpread({}, state), _newState2);
      }
    case 'SET_USER_NOTIFICATIONS':
      {
        var _newState3 = _objectSpread({}, state);
        var newNotifications = _objectSpread(_objectSpread({}, _newState3.user.notifications), action.preferences);
        var newUser = _objectSpread(_objectSpread({}, state.user), {
          notifications: newNotifications
        });
        _newState3.user = newUser;
        return _objectSpread(_objectSpread({}, state), _newState3);
      }
    case 'SET_INTEGRATIONS':
      {
        var _newState4 = _objectSpread({}, state);
        _newState4.user.integrations = action.integrations;
        return _objectSpread(_objectSpread({}, state), _newState4);
      }
    case 'SET_SUBSCRIPTION':
      {
        var _newState5 = _objectSpread({}, state);
        var ids = _toConsumableArray(_newState5.subscriptions[action.entityType]);
        var newArray = _defineProperty({}, action.entityType, action.status ? [].concat(_toConsumableArray(ids), [action.id]) : _newState5.subscriptions[action.entityType].filter(function (value) {
          return value !== action.id;
        }));
        _newState5.subscriptions = _objectSpread(_objectSpread({}, _newState5.subscriptions), newArray);
        return _objectSpread(_objectSpread({}, state), _newState5);
      }
    case 'SET_LIKE':
      {
        var _newState6 = _objectSpread({}, state);
        var _ids = _toConsumableArray(_newState6.likes[action.entityType]);
        var newLikes = _objectSpread(_objectSpread({}, _newState6.likes), _defineProperty({}, action.entityType, action.status ? [].concat(_toConsumableArray(_ids), [action.id]) : _newState6.likes[action.entityType].filter(function (value) {
          return value !== action.id;
        })));
        return _objectSpread(_objectSpread({}, state), {
          likes: newLikes
        });
      }
    case 'SET_SUBSCRIPTIONS':
      {
        var _newState7 = _objectSpread({}, state);
        _newState7.subscriptions.items = _toConsumableArray(action.subscriptions);
        var _ids2 = _toConsumableArray(_newState7.subscriptions.products);
        var products = action.subscriptions.filter(function (element) {
          return element.type === 'product';
        });
        for (var i = 0; i < products.length; i++) {
          _ids2 = [].concat(_toConsumableArray(_ids2), _toConsumableArray(products[i].items));
        }
        var tags = action.subscriptions.filter(function (element) {
          return element.type === 'tag';
        });
        var userSubscriptions = action.subscriptions.filter(function (element) {
          return element.subtype === 'user' && element.type === 'profile';
        });
        var companySubscriptions = action.subscriptions.filter(function (element) {
          return element.subtype === 'company' && element.type === 'profile';
        });
        var userIds = userSubscriptions.length ? userSubscriptions[0].items : [];
        var companyIds = companySubscriptions.length ? companySubscriptions[0].items : [];
        var articleSubscriptions = action.subscriptions.filter(function (element) {
          return element.type === 'article';
        });
        var articleLikes = action.likes.filter(function (element) {
          return element.type === 'article';
        });
        var questionSubscriptions = action.subscriptions.filter(function (element) {
          return element.type === 'question';
        });
        var questionLikes = action.likes.filter(function (element) {
          return element.type === 'question';
        });
        var reviewsLikes = action.likes.filter(function (element) {
          return element.type === 'review';
        });
        var answerLikes = action.likes.filter(function (element) {
          return element.type === 'answer';
        });
        return _objectSpread(_objectSpread({}, state), {
          socialsEntities: [].concat(_toConsumableArray(state.socialsEntities), _toConsumableArray(action.entities)),
          subscriptions: _objectSpread(_objectSpread({}, state.subscriptions), {
            items: _toConsumableArray(action.subscriptions),
            fetched: true,
            products: _toConsumableArray(_ids2),
            tags: [].concat(_toConsumableArray(tags.length ? tags[0].items : []), _toConsumableArray(_newState7.subscriptions.tags)),
            profiles: [].concat(_toConsumableArray(userIds), _toConsumableArray(companyIds)),
            articles: articleSubscriptions.length ? articleSubscriptions[0].items : [],
            questions: questionSubscriptions.length ? questionSubscriptions[0].items : []
          }),
          likes: _objectSpread(_objectSpread({}, state.likes), {
            fetched: true,
            articles: articleLikes.length ? articleLikes[0].items : [],
            questions: questionLikes.length ? questionLikes[0].items : [],
            reviews: reviewsLikes.length ? reviewsLikes[0].items : [],
            answers: answerLikes.length ? answerLikes[0].items : []
          })
        });
      }
    case 'SET_SUBSCRIPTIONS_FETCHING_STATUS':
      {
        var _newState8 = _objectSpread({}, state);
        _newState8.subscriptions.fetching = action.fetching;
        _newState8.likes.fetching = action.fetching;
        return _objectSpread(_objectSpread({}, state), _newState8);
      }
    case 'SET_SUBSCRIPTIONS_FETCHING_ENTITIES':
      {
        var _newState9 = _objectSpread({}, state);
        if (action.fetching) {
          _newState9.fetchingSocialsEntities = [].concat(_toConsumableArray(_newState9.fetchingSocialsEntities), _toConsumableArray(action.entities));
        } else {
          _newState9.fetchingSocialsEntities = _newState9.fetchingSocialsEntities.filter(function (entity) {
            return entity !== action.entities;
          });
        }
        return _objectSpread(_objectSpread({}, state), _newState9);
      }
    case 'SET_SERVICES':
      {
        var _newState10 = _objectSpread({}, state);
        _newState10.services = action.services;
        return _objectSpread(_objectSpread({}, state), _newState10);
      }
    case 'DELETE_ORGANIZATION':
      {
        var _newState11 = _objectSpread({}, state);
        _newState11.services[0].organizations = _newState11.services[0].organizations.filter(function (value) {
          return value.id !== action.idOrganization;
        });
        return _objectSpread(_objectSpread({}, state), _newState11);
      }
    case 'SET_PROFILES':
      {
        var _newState12 = _objectSpread({}, state);
        _newState12.profiles = action.profiles;
        return _objectSpread(_objectSpread({}, state), _newState12);
      }
    case ACTIONS.SET_USER_TAGS:
      {
        var _newState13 = _objectSpread({}, state);
        _newState13.tags = action.tags;
        return _objectSpread(_objectSpread({}, state), _newState13);
      }
    case 'SET_FAVORITES_FETCHING_STATUS':
      {
        var _newState14 = _objectSpread({}, state);
        _newState14.favorites.fetching = action.fetching;
        return _objectSpread(_objectSpread({}, state), _newState14);
      }
    case 'SET_FAVORITES':
      {
        var _newState15 = _objectSpread({}, state);
        _newState15.favorites = {
          fetching: false,
          fetched: true,
          products: action.favorites
        };
        return _objectSpread(_objectSpread({}, state), _newState15);
      }
    case 'SET_USER_VIEWED_TAGS_FETCHING_STATUS':
      {
        return _objectSpread(_objectSpread({}, state), {
          viewedTags: _objectSpread(_objectSpread({}, state.viewedTags), {
            fetching: action.fetching,
            fetched: action.fetched
          })
        });
      }
    case 'SET_USER_VIEWED_TAGS':
      {
        return _objectSpread(_objectSpread({}, state), {
          viewedTags: {
            items: _toConsumableArray(action.tags),
            fetching: false,
            fetched: true
          }
        });
      }
    case 'SET_USER_VIEWED_PRODUCTS_FETCHING_STATUS':
      {
        return _objectSpread(_objectSpread({}, state), {
          viewedProducts: _objectSpread(_objectSpread({}, state.viewedProducts), {
            fetching: action.fetching,
            fetched: action.fetched
          })
        });
      }
    case 'SET_USER_VIEWED_PRODUCTS':
      {
        return _objectSpread(_objectSpread({}, state), {
          viewedProducts: {
            items: _toConsumableArray(action.products),
            fetching: false,
            fetched: true
          }
        });
      }
    case 'SET_USER_PROFILE_FETCHING_STATUS':
      {
        return _objectSpread(_objectSpread({}, state), {
          profile: _objectSpread(_objectSpread({}, state.profile), {
            fetching: action.fetching,
            fetched: action.fetched
          })
        });
      }
    case 'SET_USER_PROFILE':
      {
        return _objectSpread(_objectSpread({}, state), {
          profile: _objectSpread(_objectSpread({}, state.profile), {
            model: action.profile,
            error: null,
            fetching: false,
            fetched: true
          })
        });
      }
    case 'SET_USER_PROFILE_ERROR':
      {
        return _objectSpread(_objectSpread({}, state), {
          profile: _objectSpread(_objectSpread({}, state.profile), {
            model: null,
            error: action.error,
            fetching: false,
            fetched: true
          })
        });
      }
    default:
      return state;
  }
}